// @noflow
import { parse as parseUrl, resolve as resolveUrl } from 'url';
import { StyledExternalLink, StyledRouterLink } from './styles';

import PropTypes from 'prop-types';
import * as React from 'react';
import RouterLink from 'react-router-dom/Link';

Link.propTypes = {
    alternate: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    currentHost: PropTypes.string,
    currentHref: PropTypes.string,
    href: PropTypes.string.isRequired,
    target: PropTypes.string
};

/**
 * Represents a normal inline link. If the `href` is an internal link then it
 * renders a wrapper around React Router's `<Link>`. If it's external then it
 * renders a normal `<a>`.
 */
export default function Link({
    alternate,
    children,
    className,
    currentHost = global.location.host,
    currentHref = global.location.href,
    href,
    target = '_blank',
    ...props
}) {
    if (isExternalHref(currentHost, currentHref, href)) {
        return (
            <StyledExternalLink
                alternate={alternate}
                {...props}
                className={className}
                href={href}
                rel="external noopener"
                target={target}
            >
                {children}
            </StyledExternalLink>
        );
    }

    return (
        <StyledRouterLink alternate={alternate}>
            <RouterLink {...props} className={className} to={href}>
                {children}
            </RouterLink>
        </StyledRouterLink>
    );
}

/**
 * Calculates whether `href` would be an external link
 * @param  {String}  currentHost the host of the current site
 * @param  {String}  currentHref the href of the current site
 * @param  {String}  href        the proposed href
 * @return {Boolean}             whether the proposed href would be external
 */
function isExternalHref(currentHost, currentHref, href) {
    const url = resolveUrl(currentHref, href);
    const urlParts = parseUrl(url);

    return urlParts.host !== currentHost;
}



// WEBPACK FOOTER //
// ./src/components/widgets/link/index.js